import { createAction } from '@reduxjs/toolkit';

export const faqUpdateId = createAction('faq/updateId');
export const faqUpdateUID = createAction('faq/updateUID');
export const faqUpdateSID = createAction('faq/updateSID');
export const faqUpdateIsAdded = createAction('faq/updateIsAdded');
export const faqUpdateIsActive = createAction('faq/updateIsActive');

export const faqStore = createAction('faq/store');
export const faqClear = createAction('faq/clear');

export const faqUpdateRequest = createAction('faq/updateRequest');
export const faqUpdateError = createAction('faq/updateError');
export const faqUpdateStore = createAction('faq/updateStore');

export const faqUpdateItems = createAction('faq/updateItems');
export const faqUpdateView = createAction('faq/updateView');

export const faqUpdateHeadingTitle = createAction('faq/updateHeadingTitle');
export const faqUpdateHeadingDescription = createAction('faq/updateHeadingDescription');
export const faqUpdateHeadingTextAlign = createAction('faq/updateHeadingTextAlign');
export const faqUpdateHeadingImage = createAction('faq/updateHeadingImage');
export const faqUpdateHeadingDivider = createAction('faq/updateHeadingDivider');

export const faqUpdateSectionIsBackground = createAction('faq/updateSectionIsBackground');
export const faqUpdateSectionTextColor = createAction('faq/updateSectionTextColor');
export const faqUpdateSectionBackgroundColor = createAction('faq/updateSectionBackgroundColor');
export const faqUpdateSectionOpacity = createAction('faq/updateSectionOpacity');
export const faqUpdateSectionIsFullWidth = createAction('faq/updateSectionIsFullWidth');
export const faqUpdateSectionShadow = createAction('faq/updateSectionShadow');
export const faqUpdateSectionShadowColor = createAction('faq/updateSectionShadowColor');
export const faqUpdateSectionPadding = createAction('faq/updateSectionPadding');
export const faqUpdateSectionMargin = createAction('faq/updateSectionMargin');
export const faqUpdateSectionBackgroundType = createAction('faq/updateSectionBackgroundType');
export const faqUpdateSectionBackgroundImage = createAction('faq/updateSectionBackgroundImage');
export const faqUpdateSectionGradientColor1 = createAction('faq/updateSectionGradientColor1');
export const faqUpdateSectionGradientColor2 = createAction('faq/updateSectionGradientColor2');
export const faqUpdateSectionGradientDirection = createAction('faq/updateSectionGradientDirection');
export const faqUpdateSectionGradientOffset = createAction('faq/updateSectionGradientOffset');
export const faqUpdateSectionBorder = createAction('faq/updateSectionBorder');
export const faqUpdateSectionBorderColor = createAction('faq/updateSectionBorderColor');
export const faqUpdateSectionShadowBorderColor = createAction('faq/updateSectionShadowBorderColor');
export const faqUpdateSectionShape = createAction('faq/updateSectionShape');

export const faqUpdateItemOpacity = createAction('faq/updateItemOpacity');
export const faqUpdateItemShadow = createAction('faq/updateItemShadow');
export const faqUpdateItemShadowColor = createAction('faq/updateItemShadowColor');
export const faqUpdateItemBorder = createAction('faq/updateItemBorder');
export const faqUpdateItemBorderColor = createAction('faq/updateItemBorderColor');
export const faqUpdateItemShape = createAction('faq/updateItemShape');
export const faqUpdateItemTextColor = createAction('faq/updateItemTextColor');
export const faqUpdateItemBackgroundColor = createAction('faq/updateItemBackgroundColor');
